import React from "react";
import YouTube from "react-youtube";

const VideoPlayer = ({  videoUrl }) => {
  const videoId = getVideoIdFromUrl(videoUrl);
  const opts = {
    height: "0", // Set to 0 to maintain the aspect ratio with padding
    width: "100%", // Take up the full width
  };

  return (
    <div className="video-player relative" style={{ paddingTop: "56.25%" }}>
      {/* 16:9 Aspect Ratio */}
      <YouTube videoId={videoId} opts={opts} />
    </div>
  );
};

export default VideoPlayer;

function getVideoIdFromUrl(url) {
  // Regular expression to match the video ID
  const regex = /[?&]v=([^?&]+)/;
  const match = url.match(regex);
  if (match && match[1]) {
    return match[1];
  } else {
    // Handle invalid URLs or no match
    return null;
  }
}
